import React from 'react'
import { InputHLPure, DialogFormHLPure } from '../../pures'

const DialogAddUserPure = ({
    showDialog,
    type, // 'collaborator' o 'invited'
    t,
    newUser = {},
    userErrors = {},
    handlers = {}
}) => {
    if (!showDialog) return null

    const isCollaborator = type === 'collaborator'
    const titleKey = isCollaborator
        ? 'digitalVault.share.newCollaborator'
        : 'digitalVault.share.newInvited'

    const handleClose =
        isCollaborator
            ? handlers?.handleCloseAddCollaborator
            : handlers?.handleCloseAddInvited

    const handleSubmit =
        isCollaborator
            ? handlers?.handleAddCollaboratorSubmit
            : handlers?.handleAddInvitedSubmit

    const handleChange =
        isCollaborator
            ? handlers?.handleAddCollaboratorChange
            : handlers?.handleAddInvitedChange

    return (
        <DialogFormHLPure
            titleDialog={t(titleKey) || (isCollaborator ? 'Nuevo colaborador' : 'Nuevo invitado')}
            textBtnCancel={t('button.back') || 'Regresar'}
            saveBtn={t('button.save') || 'Guardar'}
            cancel={() => handleClose && handleClose()}
            handleSubmit={(e) => handleSubmit && handleSubmit(e)}
        >
            <div className='dialog-invitation-form'>
                {/* Email */}
                <div style={{ marginBottom: 14, lineHeight: 1 }}>
                    <InputHLPure
                        required
                        typeInput='email'
                        labelInput={t('dialogSignerList2.email') || 'Correo'}
                        inputTypeBox={false}
                        valueInput={newUser.email || ''}
                        handleChangeInput={(e) => handleChange && handleChange(e, 'email')}
                        inputActive
                    />
                    {userErrors?.emailInvalid && (
                        <span className='hint-message-error'>
                        </span>
                    )}
                    {userErrors?.emailExists && !userErrors?.emailInvalid && (
                        <span className='hint-message-error'>
                            {t('dialogSignerList2.errorEmailAlreadyRegister') || 'El correo ya está registrado'}
                        </span>
                    )}
                    {Boolean(userErrors?.domainError) && (
                        <span className='hint-message-error'>{userErrors.domainError}</span>
                    )}
                </div>

                {/* Nombre */}
                <div style={{ marginBottom: 14, lineHeight: 1 }}>
                    <InputHLPure
                        required
                        typeInput='text'
                        labelInput={t('dialogSignerList2.name') || 'Nombre'}
                        valueInput={newUser.firstName || ''}
                        handleChangeInput={(e) => handleChange && handleChange(e, 'firstName')}
                        inputActive
                    />
                    {userErrors?.firstName && (
                        <span className='hint-message-error'>
                            {t('dialogSignerList2.errorFirstNamesNotvalid') || 'Nombre no válido'}
                        </span>
                    )}
                </div>

                {/* Apellido */}
                <div style={{ marginBottom: 14, lineHeight: 1 }}>
                    <InputHLPure
                        required
                        typeInput='text'
                        labelInput={t('dialogSignerList2.lastName') || 'Apellido'}
                        valueInput={newUser.lastName || ''}
                        handleChangeInput={(e) => handleChange && handleChange(e, 'lastName')}
                        inputActive
                    />
                    {userErrors?.lastName && (
                        <span className='hint-message-error'>
                            {t('dialogSignerList2.errorLastNamesNotvalid') || 'Apellido no válido'}
                        </span>
                    )}
                </div>
            </div>
        </DialogFormHLPure>
    )
}

export default DialogAddUserPure
